import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { DashService } from '@modules/dash-board/dash.service';
import { HistoryService } from '@services/api/history.service';
import { MessageService } from '@services/util/message.service';
import { debounceTime, distinctUntilChanged, Subject } from 'rxjs';

@Component({
  selector: 'app-remmi-history',
  templateUrl: './remmi-history.component.html',
  styleUrls: ['./remmi-history.component.scss'],
})
export class RemmiHistoryComponent {
  @Input() module: string = '';
  @Input() record_id: string = '';
  @ViewChild('scrollableElement') scrollableElement!: ElementRef;
  private searchSubject = new Subject<string>();

  rows: number = 30;
  page: number = 1;
  isLoading: boolean = true;
  scrollTop: number = 0;
  totalRecord = 0;
  historyList: any[] = [];
  history_keyword = '';
  previousScrollTop = 0;
  pageLoad = false;
  mobToggle: boolean = false;
  constructor(
    private message: MessageService,
    private _historyService: HistoryService,
    private dash: DashService
  ) {}

  ngOnInit(): void {
    this.pageLoad = true;
    this.getHistoryList();
    this.message.setModuleHistory().subscribe({
      next: _ => {
        this.getHistoryList();
      },
    });
    this.searchSubject.pipe(debounceTime(400), distinctUntilChanged()).subscribe({
      next: _ => {
        this.getHistoryList();
      },
    });

    this.dash.screenSize$.subscribe(size => {
      if (size.width < 768) {
        this.mobToggle = true;
      } else {
        this.mobToggle = false;
      }
    });
  }

  getHistoryList(pageNo = 1, perPage = 30, bool = false) {
    // Fetch history data for the given record_id and module
    this._historyService.getHistoryListByModuleName(this.module, this.record_id, pageNo, perPage, this.history_keyword).subscribe({
      next: response => {
        let history = [];
        this.isLoading = true;

        // Normalise a single history record (boolean values -> Yes/No, add isOpen flag)
        const normalize = ele => {
          if (typeof ele?.fields?.old_value == 'boolean' || typeof ele?.fields?.new_value == 'boolean') {
            ele.fields.old_value = ele?.fields?.old_value ? 'Yes' : 'No';
            ele.fields.new_value = ele?.fields?.new_value ? 'Yes' : 'No';
          }
          return { ...ele, isOpen: true };
        };

        // AI Correction writes ONE history doc whose `fields` is an ARRAY of changes.
        // The table reads `fields` as a single object, so expand each change into its
        // own display row. Normal docs (fields = object) pass through unchanged.
        history = response.data.flatMap(ele => {
          if (Array.isArray(ele?.fields)) {
            return ele.fields.map(f => normalize({ ...ele, fields: { ...f } }));
          }
          return normalize(ele);
        });

        if (bool) {
          // Append new history records to the existing list
          this.historyList.push(...history);

          // Stop loading if fewer than 30 records are received
          if (history?.length < 30) {
            this.isLoading = false;
            this.rows = this.historyList.length;
          } else {
            this.rows += 30;
          }
        } else {
          // Reset pagination and replace history list
          this.page = 1;
          this.rows = 30;
          this.historyList = history;
        }
        this.pageLoad = false;
        // Update the total record count from the API response
        this.totalRecord = response['meta']?.['pagination']?.['total'];
      },
    });
  }

  getDisplayValue(value: any, isOpen: boolean): string {
    if (value === 'retail') {
      return 'Retail';
    }

    if (value === null || value === undefined) {
      return '';
    }

    const stringValue = String(value);

    return isOpen ? stringValue.slice(0, 20) : stringValue;
  }
  isDate(value: any): boolean {
    return !isNaN(new Date(value).getTime());
  }

  toggleCollapse(box) {
    box.isOpen = !box.isOpen;
  }

  scrollToTop(): void {
    const element = this.scrollableElement.nativeElement as HTMLElement;
    element.scrollTop = 0;
  }
  onScroll(event: Event): void {
    const element = event.target as HTMLElement;
    this.scrollTop = element.scrollTop;

    // Determine if the user is scrolling down
    const isScrollingDown = this.scrollTop > this.previousScrollTop;
    this.previousScrollTop = this.scrollTop;

    if (isScrollingDown && this.isLoading) {
      console.log('Working ' + this.rows);
      this.page = this.page + 1;
      this.isLoading = false;
      this.getHistoryList(this.page, 30, true);
    }
  }

  searchHistory() {
    this.historyList = [];
    this.searchSubject.next(this.history_keyword);
  }

  showFieldName(field) {
    return field == 'AvailableDate' ? 'Available Date' : field == 'PetFriendly' ? 'Pet Friendly' : field == 'Spaces' ? 'Car' : field;
  }

  // parseValue(value){
  //   return JSON.parse(value)
  // }
}
